module.exports = __webpack_public_path__ + "static/group1_1-bfb81a25d7fb9cc62591459903fdde46.webp";